/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { CodeEntryMeta } from './codeEntryMeta';
import { GlaeubigerVersionIdMeta } from './glaeubigerVersionIdMeta';
import { PersonGbListEntryMeta } from './personGbListEntryMeta';


export interface GlaeubigerVersionDetailEntryMeta { 
    glaeubigerrolle?: GlaeubigerVersionDetailEntryMeta.GlaeubigerrolleEnum;
    mGlaeubigerrolle?: FieldMetaData;
    personGb?: PersonGbListEntryMeta;
    mPersonGb?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    id: GlaeubigerVersionIdMeta;
    mId?: FieldMetaData;
    codeGlaeubigerrolle?: CodeEntryMeta;
    mCodeGlaeubigerrolle?: FieldMetaData;
}
export namespace GlaeubigerVersionDetailEntryMeta {
    export type GlaeubigerrolleEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const GlaeubigerrolleEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        NUTZNIESSER: 'NUTZNIESSER' as GlaeubigerrolleEnum,
        ANDEREROLLE: 'ANDEREROLLE' as GlaeubigerrolleEnum
    };
}


